module.exports = __webpack_public_path__ + "img/guanziqian.asm.f43f3f41.jpg";